const type = 'SET_RECHARGE_SMS_SENT';

const setRechargeSMSSent = () => ({
  type,
});

export default setRechargeSMSSent;
